import { ICopyable } from '../controls/common/icopyable';
import { IListLayoutColumn } from './interfaces/list-layout-column.interface';

export class ListLayoutColumn implements IListLayoutColumn, ICopyable<IListLayoutColumn> {
    public id: number = null;
    public position: number = null;
    public size: number = null;
    public isStickyColumn: boolean = false;
    public attributeId: number = null;
    public attributeName: string = null;
    public nonEditable: boolean = false;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): ListLayoutColumn {
        const instance = new ListLayoutColumn();
        instance.id = this.id;
        instance.position = this.position;
        instance.size = this.size;
        instance.attributeId = this.attributeId;
        instance.isStickyColumn = this.isStickyColumn;
        instance.nonEditable = this.nonEditable;
        return instance;
    }

    public static createFormCopy(listLayoutColumn: ListLayoutColumn): IListLayoutColumn {
        const instance = new ListLayoutColumn();
        instance.id = listLayoutColumn.id;
        instance.position = listLayoutColumn.position;
        instance.size = listLayoutColumn.size;
        instance.attributeId = listLayoutColumn.attributeId;
        instance.isStickyColumn = listLayoutColumn.isStickyColumn;
        instance.nonEditable = listLayoutColumn.nonEditable;
        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.position = other.position;
        this.size = other.size;
        this.attributeId = other.attributeId;
        this.isStickyColumn = other.isStickyColumn;
        this.nonEditable = other.nonEditable;
        this.attributeName = other.attributeName;
    }
}
